import DialogSize from '@/calendesk/models/DialogSize'

export default class Dialog {
  public open: boolean;
  public persistent: boolean;
  public type: number;
  public size: number;
  public displayFooter: boolean;
  public title: string | null;
  public justifyTitle: string;
  public data: Record<string, any>;

  constructor (open = false, type = 0, title = null as null | string, size = DialogSize.SMALL, displayFooter = false, justifyTitle = 'center', data: Record<string, any> = {}, persistent = false) {
    this.open = open
    this.type = type
    this.size = size
    this.displayFooter = displayFooter
    this.title = title
    this.justifyTitle = justifyTitle
    this.data = data
    this.persistent = persistent
  }
}
